import { isWebView, WebViewPlatform } from "../../../src/constants/index";
import { platform } from "../../enum/Platform";
import { setGetCoordinateToCookieByAreaId } from "../utils/Location";
import LocationApi from "../apis/LocationApis";
import { getDetectLocationErrorMessage } from "SrcPath/utils/Location";

export function syncAreaCityFromWebView(location) {
  if (isWebView) {
    if (WebViewPlatform.id === platform.ANDROID.id) {
      Android.syncAreaCityFromWebView(JSON.stringify(location));
    } else if (WebViewPlatform.id === platform.IOS.id) {
      webkit.messageHandlers.syncAreaCityFromWebView.postMessage(
        JSON.stringify(location)
      );
    }
  }
}

export function syncLatLongToWebView(lat, long) {
  if (!isNaN(lat) && !isNaN(long)) {
    let position = {};
    position.coords = {};
    position.coords.latitude = lat;
    position.coords.longitude = long;
    let shouldUpdateLatLonInStore = false;
    this.props.detectLocation({
      position,
      shouldUpdateLocation,
      shouldUpdateLatLonInStore,
    });
  }
}

export function syncAreaCityToWebView(areaCity) {
  areaCity = JSON.parse(areaCity);
  const cityId = parseInt(areaCity.cityId);
  const cityName = parseInt(areaCity.cityName);
  const areaId = parseInt(areaCity.areaId);
  const areaName = parseInt(areaCity.areaName);

  if (!isNaN(cityId) && cityId > 0) {
    this.props.setCity({
      cityId,
      cityName,
      isConfirmBtnClicked: true,
    });
  }

  if (!isNaN(areaId) && areaId > 0) {
    this.props.setArea({ areaId, areaName });
    setGetCoordinateToCookieByAreaId(areaId);
  }
}

export const getNearestAddressWebView = (
  latitude,
  longitude,
  successCallback,
  errorCallback
) => {
  LocationApi.getAddress(latitude, longitude)
    .then(response => {
      successCallback(response);
    })
    .catch(error => {
      const message = getDetectLocationErrorMessage(error);
      errorCallback(message);
    });
};

function shouldUpdateLocation(location) {
  let locationObj = {
    cityId: location.cityId,
    cityName: location.cityName,
    areaId: "-1",
    areaName: "",
  };
  syncAreaCityFromWebView(locationObj);
  return true;
}
